import createViewportMeta from "./create-viewport-meta";
import state from "./state";

/**
 * Sets html[data-convo] attribute to "maximized",
 * captures current scroll position and removes initial
 * iframe positioning
 *
 * @param {HTMLIFrameElement} iframe
 * @returns {undefined}
 */
export default function maximize(iframe) {
  state.update((s) => ({
    ...s,
    scrollPos: {
      x: window.pageXOffset,
      y: window.pageYOffset
    }
  }));
  iframe.style.cssText = null;
  document.documentElement.dataset.convo = "maximized";
  createViewportMeta();
  iframe.dispatchEvent(new CustomEvent("speakeasy:embed:maximize"));
}
